<template>
  <span id="print-bill-of-lading-bulk" v-if="billOfLading.total">
    <el-button id="btn-print-bill-of-lading-bulk" v-if="!billOfLading.isInBulkPrinting" type="success" plain @click="handleToggleBulkPrint(true)" size="mini">{{ $t('customerService.billOfLading.printBols') }}</el-button>
    <el-button id="btn-cancel-print-bill-of-lading-bulk" v-if="billOfLading.isInBulkPrinting" type="default" @click="handleToggleBulkPrint(false)" size="mini">{{ $t('common.cancel') }}</el-button>
    <el-button id="btn-submit-print-bill-of-lading-bulk" v-if="billOfLading.isInBulkPrinting" type="primary" @click="dialogVisible = true" size="mini">{{ $t('customerService.billOfLading.printBols') }}</el-button>
    <el-dialog
      width="25%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('customerService.billOfLading.print')"
      class="dialog-with-cols"
    >
      <el-row>
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="bulkPrint(true)">
            {{ $t('outbound.loads.detailedBol') }}
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="bulkPrint(false)">
            {{ $t('outbound.loads.bol') }}
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'PrintBillOfLadingBulk',
  computed: {
    ...mapGetters(['billOfLading'])
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    handleToggleBulkPrint(isInBulkPrinting) {
      this.$store.dispatch('billOfLading/setIsInBulkPrinting', isInBulkPrinting);
    },
    async bulkPrint(printDetailed) {
      if (this.billOfLading.bulkPrintAllChecked || this.billOfLading.bulkPrintIds.length) {
        this.dialogVisible = false;
        const loading = Loading.service(constants.LOADING.PRINT_BOLS_CONFIG);
        await this.$store.dispatch('billOfLading/bulkPrint', printDetailed);
        loading.close();
        this.handleToggleBulkPrint(false);
      } else {
        this.$message.warning(this.$t('customerService.billOfLading.selectBolsToPrint'));
      }
    }
  },
  beforeDestroy() {
    this.handleToggleBulkPrint(false);
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#print-bill-of-lading-bulk {
  .el-dialog {
    .el-button {
      margin-bottom: 10px;
      width: 100%;
    }
  }
}
</style>
